import { useContext } from "react";

import { PatientPageContext } from "../contexts/PatientPageContext";

export function usePatientPage() {
  const context = useContext(PatientPageContext);

  return context;
}
